import { getCoreDataSecurityAccessAuditByIdSlice } from './get';

export const { requestGetCoreDataSecurityAccessAuditById, resetGetCoreDataSecurityAccessAuditById } =
	getCoreDataSecurityAccessAuditByIdSlice.asyncActionCreators;


